module.exports = new __parcel__URL__("workflow-builder-splash-darkmode.7000c4e5.svg").toString();